<template>
  <div class="home">
    <div class="images">
      <loop-play-images
        v-if="bannerImagesData != null"
        :images-data="bannerImagesData"
        :background-appe-mode="false"
        :default-classes="loopPlayImagesData.defaultClasses"
      />
    </div>
    <div class="popular_box"></div>
    <div style="margin-top: 540px"></div>
    <ImageList
      v-for="(item, index) in templateData"
      :key="index"
      :info="item"
      @moreClick="moreContentsClick"
      @movieClick="movieClick"
    />
    <div class="advertisement" v-if="bottomBanner">
      <a :href="bottomBanner.link" target="_blank">
        <img :src="bottomBanner.image" :alt="bottomBanner.title" />
      </a>
    </div>
    <div class="flotation">
      <div class="flotation_top" v-show="flotationSelect == 'WeChat' || flotationSelect == 'phone'">
        <img v-if="flotationSelect == 'WeChat'" src="/img/newPages/weixin-1.jpg" alt="" />
        <img v-if="flotationSelect == 'phone'" src="https://resstatic.today365.com.cn/wstatic/static/image/qrcode.png" alt="" />
        <span>瑞网微视下载</span>
      </div>
      <div class="flotation_bottom">
        <div :class="flotationSelect == 'WeChat' ? 'select' : ''" @mouseover="QRcode('WeChat')" @mouseleave="QRcode('none')">
          <img src="/img/newPages/weixin_icon.png" alt="" />
        </div>
        <div :class="flotationSelect == 'phone' ? 'select' : ''" @mouseover="QRcode('phone')" @mouseleave="QRcode('none')">
          <img src="/img/newPages/shouji_icon.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoopPlayImages from '@/components/common/LoopPlayImages.vue'
import ImageList from '@/components/common/ImageList.vue'
import { getToken } from '@/utils/auth'

export default {
  name: 'Home',
  components: {
    LoopPlayImages,
    ImageList
  },
  data() {
    return {
      bannerImagesData: null,
      templateData: [],
      bottomBanner: null,
      flotationSelect: 'none',
      loopPlayImagesData: {
        defaultClasses: {
          outerRotateStage: 'loopImages',
          rotateStage: 'loopStage',
          innerShow: 'loopContainer',
          btn: 'btnOuter',
          circular: 'dots'
        }
      }
    }
  },
  mounted() {
    this.getPageData()
  },
  methods: {
    getPageData() {
      this.$axios({
        url: '/realNet/pageManager/findOne',
        method: 'get',
        params: { title: '首页' },
        headers: { token: getToken() || '123456789' }
      }).then(res => {
        if (res.data.result) {
          const dataMap = res.data.result.dataMap || res.data.result
          this.bottomBanner = dataMap.bottomBanner ? dataMap.bottomBanner[0] : null
          if (dataMap.bannerList) {
            this.bannerImagesData = dataMap.bannerList.map(t => ({
              backgroundImage: t.image,
              imageLinkRouterName: t.link
            }))
          }
          if (dataMap.contentTemplateList) {
            this.loadTemplates(dataMap.contentTemplateList)
          }
        }
      })
    },
    loadTemplates(contentTemplateList) {
      const results = new Array(contentTemplateList.length)
      let completed = 0
      contentTemplateList.forEach((template, index) => {
        const params = {
          orderByField: template.searchSortOrder,
          orderByType: template.searchSortOrderType,
          pageSize: 8,
          pageNum: 0,
          hasLeaderboardData: true
        }
        try {
          const searchField = JSON.parse(template.searchField)
          if (searchField) Object.assign(params, searchField)
        } catch (e) {}
        this.$axios({
          url: '/realNet/video/getVideoInfos',
          method: 'get',
          headers: { token: getToken() || '123456789' },
          params
        }).then(res => {
          const content = res.data.result ? res.data.result.content : null
          const leaderboardContent = res.data.result ? res.data.result.leaderboardContent : null
          const info = {
            title: template.name,
            list: [],
            mainList: [],
            isSeniority: template.displayLeaderboard === 1,
            isContent: true,
            recommendList: [],
            seniorityInfo: {
              title: '排行榜',
              type: 'name',
              list: []
            }
          }
          const seniorityInfo = {
            title: '排行榜',
            type: 'name',
            list: []
          }
          if (content) {
            content.forEach((item, idx) => {
              let img = item.verticalImage
              if ((template.firstImageFeature && idx === 0) || template.usageImage === 1) {
                img = item.horizontalImage
              }
              if (idx < 5) {
                info.mainList.push({
                  id: item.id,
                  img: img,
                  name: item.videoName,
                  intro: item.description,
                  title: item.videoName
                })
              } else {
                info.recommendList.push({
                  id: item.id,
                  name: item.videoName
                })
              }
            })
            if (leaderboardContent) {
              leaderboardContent.forEach((item, idx) => {
                if (idx < 8) {
                  seniorityInfo.list.push({
                    id: item.id || '',
                    name: item.videoName,
                    grade: item.score
                  })
                }
              })
            }
            if (template.usageImage === 1) {
              seniorityInfo.list = seniorityInfo.list.slice(0, 5)
            }
            info.seniorityInfo = seniorityInfo
            info.list = info.mainList
          }
          results[index] = info
          completed++
          if (completed === contentTemplateList.length) {
            this.templateData = results
          }
        })
      })
    },
    moreContentsClick(info) {
      this.$router.push({
        path: '/special-page',
        query: {
          pageTitle: info.title,
          detailPage: this.getDetailPageName(info.title)
        }
      })
    },
    movieClick(item) {
      const title = item.title || item.name || ''
      if (title.toUpperCase().indexOf('RMHD') > -1) {
        this.$router.push({ path: '/download-detail', query: { id: item.id } })
      } else {
        this.$router.push({ path: '/tvplay-page', query: { id: item.id } })
      }
    },
    getDetailPageName(title) {
      return title && title.toUpperCase().indexOf('RMHD') > -1 ? 'DownloadDetailPage' : 'TVplayPage'
    },
    QRcode(type) {
      this.flotationSelect = type
    }
  }
}
</script>

<style lang="scss" scoped>

.home {
  overflow: hidden;
}

.home ::v-deep .btnOuter,
.home ::v-deep .dots {
  display: none;
}

.images {
  position: absolute;
  top: 0;
  width: 100%;
  z-index: -1;

  ::v-deep img {
    z-index: 1;
    width: 100%;
    position: relative;
    height: 576px !important;
  }

  ::v-deep #loopImages {
    height: 576px !important;
  }
}

.popular_box {
  width: 100%;
  height: 446px;
  background: linear-gradient(180deg, rgba(50, 40, 210, 0.3), rgba(209, 47, 60, 0));
  position: absolute;
  top: 576px;
  z-index: 3;
}

.advertisement {
  margin-top: 30px;
  img {
    width: 100%;
    border-radius: 5px;
  }
}

.flotation {
  position: fixed;
  bottom: 200px;
  right: 246px;
  z-index: 99;
  width: 165px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .flotation_top {
    width: 165px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    font-family: PingFang;
    font-weight: 400;
    font-size: 14px;
    color: #000;
    padding-top: 14px;
    padding-bottom: 39px;
    box-sizing: border-box;
    background-size: 100% 100%;

    img {
      width: 139px;
      height: 139px;
    }
  }

  .flotation_bottom {
    width: 50px;
    height: 101px;
    background: #fff;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);
    border-radius: 5px;
    cursor: pointer;

    div {
      width: 50px;
      height: 50px;
      background: #d1d6da;
      display: flex;
      justify-content: center;
      align-items: center;

      &:first-child {
        border-radius: 5px 5px 0 0;

        img {
          width: 30px;
          height: 27px;
        }
      }

      &:nth-child(2) {
        border-radius: 0 0 5px 5px;
        margin-top: 1px;

        img {
          width: 21px;
          height: 30px;
        }
      }

      &.select {
        background: #97a2a6;
      }
    }
  }
}
</style>
